import { Search, useTheme } from '@h2oai/ui-kit';
import { useEffect, useState } from 'react';

import { LoginEventsRequest, LoginStatisticsResponse } from '../../admin-center/gen/user_login/userlogin_pb';
import { useAdminCenterService } from '../../admin-center/hooks';
import { useUser } from '../../utils/hooks';
import { useTimeFilters } from './common/hooks';
import { buildUserContext, formatDateLocal } from './common/utils';
import TimeFilters from './components/TimeFilters/TimeFilters';
import {
  InfoLabel,
  InfoValue,
  searchAreaStyle,
  tableAreaStyle,
  UserLoginPageStatStyles,
} from './components/UserLogin/UserLogin.styles';
import UserLoginTable from './components/UserLogin/UserLoginTable/UserLoginTable';
import PageWrapper from './PageWrapper';

export default function UserLogin() {
  const service = useAdminCenterService();
  const theme = useTheme();
  const user = useUser();
  const { startDate, endDate, selectedTimeFrame, handleTimeFilterChange } = useTimeFilters();
  const [stats, setStats] = useState<LoginStatisticsResponse | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchLoginStats = async () => {
    try {
      const userContext = await buildUserContext(user);
      const request: LoginEventsRequest = {
        startDate: formatDateLocal(startDate),
        endDate: formatDateLocal(endDate),
        userContext: userContext,
      };

      const response = await service.getUserLoginEventsStats(request);
      setStats(response);
    } catch (error) {
      console.error('Error fetching login statistics:', error);
    }
  };

  useEffect(() => {
    fetchLoginStats();
  }, [startDate, endDate]);

  return (
    <PageWrapper>
      <TimeFilters
        startDate={startDate}
        endDate={endDate}
        selectedTimeFrame={selectedTimeFrame}
        onChange={handleTimeFilterChange}
        styles={{
          filterContainer: {
            marginLeft: 'auto',
            width: 'fit-content',
            marginBottom: '1.5rem',
          },
        }}
      />

      <div style={UserLoginPageStatStyles(theme)}>
        <div>
          <p style={InfoLabel}>Total login count:</p>
          <p style={InfoValue}>{stats?.totalLoginCount ?? '-'}</p>
        </div>
        <div>
          <p style={InfoLabel}>Unique user count:</p>
          <p style={InfoValue}>{stats?.uniqueUserCount ?? '-'}</p>
        </div>
        <div>
          <p style={InfoLabel}>Most logged in user:</p>
          <p style={InfoValue}>{stats?.mostLoggedInUser ?? '-'}</p>
        </div>
        <div>
          <p style={InfoLabel}>Unique user domains:</p>
          <p style={InfoValue}>{stats?.uniqueUserDomains ?? '-'}</p>
        </div>
        <div>
          <p style={InfoLabel}>Most logged user domain:</p>
          <p style={InfoValue}>{stats?.mostLoggedUserDomain ?? '-'}</p>
        </div>
      </div>

      <div style={searchAreaStyle}>
        <Search
          emptyMessage="No results found"
          placeholder="Search user logins..."
          onSearchTextChange={(text: string) => setSearchQuery(text)}
          style={{ width: '250px', marginRight: '20px' }}
        />
      </div>
      <div style={tableAreaStyle}>
        <UserLoginTable
          startDate={formatDateLocal(startDate)}
          endDate={formatDateLocal(endDate)}
          searchQuery={searchQuery}
        />
      </div>
    </PageWrapper>
  );
}
